import { render } from "./cargo-v2-detail-info.vue?vue&type=template&id=2a0471c4&scoped=true&ts=true"
import script from "./cargo-v2-detail-info.vue?vue&type=script&lang=ts"
export * from "./cargo-v2-detail-info.vue?vue&type=script&lang=ts"

import "./cargo-v2-detail-info.vue?vue&type=style&index=0&id=2a0471c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0471c4"]])

export default __exports__